import { useJustAddedPaymentMethod } from '@/components/billing/useJustAddedPaymentMethod';
import { useUserData } from '@/services/user';

export const useIsPaymentRequired = () => {
    const { membership } = useUserData();
    const [justAddedPaymentMethod] = useJustAddedPaymentMethod();

    return (
        membership?.status === 'PAUSED' &&
        !membership?.paymentMethodInfo &&
        !justAddedPaymentMethod
    );
};
